interface MarketCapCategoryBound {
  label: string;
  min: number;
  max: number | null;
}

// Mirrors the backend's category boundaries (app/constants/market_cap.py).
const MARKET_CAP_CATEGORY_BOUNDS: MarketCapCategoryBound[] = [
  { label: 'Micro Cap', min: 0, max: 250e6 },
  { label: 'Small Cap', min: 250e6, max: 2e9 },
  { label: 'Mid Cap', min: 2e9, max: 10e9 },
  { label: 'Large Cap', min: 10e9, max: 200e9 },
  { label: 'Mega Cap', min: 200e9, max: null },
];

function formatBound(value: number): string {
  if (value >= 1e9) {
    return `$${value / 1e9}B`;
  }
  if (value >= 1e6) {
    return `$${value / 1e6}M`;
  }
  return `$${value}`;
}

/**
 * Market cap category label (e.g. "Small Cap") to its $ range, written out
 * (e.g. "$250M - $2B", or "$200B+" for the open-ended top category).
 */
export const MARKET_CAP_CATEGORY_RANGE_LABEL: Record<string, string> =
  Object.fromEntries(
    MARKET_CAP_CATEGORY_BOUNDS.map(({ label, min, max }) => [
      label,
      max == null
        ? `${formatBound(min)}+`
        : `${formatBound(min)} - ${formatBound(max)}`,
    ]),
  );
